import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import RecipeForm from '@/components/manufacturing/RecipeForm';
import ManufacturingService from '@/api/manufacturing.service';

const CreateRecipe: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const businessId = parseInt(localStorage.getItem('businessId') || '1');

  const handleSubmit = async (data: any) => {
    setIsLoading(true);
    try {
      const response = await ManufacturingService.createRecipe(businessId, data);

      if (response.data?.success) {
        toast({
          title: "Success",
          description: "Recipe created successfully",
        });
        navigate('/manufacturing/recipes');
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: response.data?.message || "Failed to create recipe",
        });
      }
    } catch (error: any) {
      console.error('Error creating recipe:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to create recipe",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/manufacturing/recipes')}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Recipes
        </Button>
      </div>

      <div>
        <h1 className="text-3xl font-bold tracking-tight">Create Recipe</h1>
        <p className="text-muted-foreground">
          Create a new manufacturing recipe with bill of materials
        </p>
      </div>

      <RecipeForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
};

export default CreateRecipe; 